import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Input, { INPUT_TYPES } from '../Input/Input';
import './fancy_toggle.scss';

export default  class FancyToggle extends Component {
  static propTypes = {
    className: PropTypes.string,
    onText: PropTypes.string,
    onColorClass: PropTypes.string.isRequired,
    offColorClass: PropTypes.string.isRequired,
    offText: PropTypes.string,
    toggleWidthClassName: PropTypes.string,
  };

  static defaultProps = {
    onText: 'ON',
    offText: 'OFF',
    onColorClass: 'green',
    offColorClass: 'darkGrey',
  };

  render() {
    const currentColor = this.props.checked
      ? this.props.onColorClass
      : this.props.offColorClass;

    return (
      <Input
        {...this.props}
        data-testid={this.props.id}
        className={cx(
          'fancy_toggle flex justify-between',
          this.props.className,
          { checked: this.props.checked }
        )}
        inputClassName={cx(
          'shadow z-10 absolute appearance-none opacity-0 m-0 cursor-pointer w-full',
          this.props.inputClassName
        )}
        type={INPUT_TYPES.CHECKBOX}
        inputWrapperClassName={this.props.toggleWidthClassName}
        foreignComponent={
          <Fragment>
            <div
              className={`fancy_toggle__text absolute w-full h-full t-50 text-xs text-${currentColor} font-bold`}>
              {this.props.checked ? this.props.onText : this.props.offText}
            </div>
            <div
              className={`fancy_toggle__knob absolute rounded-full t-50 bg-${currentColor}`}
            />
          </Fragment>
        }
      />
    );
  }
}
